import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { type AvgRatingResponse } from '@/types/all-profiles.types';
import { arrayToMap } from '@/utils/array-to-map';

export const setAllProfilesAvgRating = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<AvgRatingResponse[]>((state, action) => {
    const map = arrayToMap<AvgRatingResponse>('bl_profile', action.payload);
    state.allProfiles.users = state.allProfiles.users.map((user) => ({
      ...user,
      avg_rating: user.bl_profile ? map.get(user.bl_profile)?.avg_rating : 0,
    }));
    state.allProfiles.loadingStarScore = false;
  });
